import { render, staticRenderFns } from "./chengxing.vue?vue&type=template&id=cc37049a&scoped=true&"
import script from "./chengxing.vue?vue&type=script&lang=js&"
export * from "./chengxing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc37049a",
  null
  
)

export default component.exports